import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.872 13.848 13.21 12.27a3.11 3.11 0 0 0-2.457.002l-3.637 1.575c-.603.26-.977.83-.978 1.486 0 .656.373 1.227.973 1.49l1.555.678v2.16a2.09 2.09 0 0 0 1.211 1.894C10.52 21.85 11.232 22 12 22s1.48-.15 2.123-.444a2.09 2.09 0 0 0 1.21-1.894v-2.167l.834-.362v2.368a.833.833 0 1 0 1.666 0v-4.167a1.6 1.6 0 0 0-.961-1.486m-5.455-.046c.36-.156.775-.156 1.135-.001l3.625 1.48c0 .012-.006.021-.007.033l-3.613 1.57c-.363.157-.78.157-1.143-.002l-3.636-1.505zm2.25 5.859a.42.42 0 0 1-.241.38c-.842.386-2.011.386-2.851 0a.41.41 0 0 1-.242-.38v-1.433l.415.181a3.1 3.1 0 0 0 2.475.002l.444-.194zM7.833 5.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m3.334 0a1.25 1.25 0 1 1-2.501 0 1.25 1.25 0 0 1 2.5 0M17.833 2H6.167A4.17 4.17 0 0 0 2 6.167v10a4.17 4.17 0 0 0 4.167 4.166.833.833 0 1 0 0-1.666 2.503 2.503 0 0 1-2.5-2.5V9.5h16.666v6.667c0 .609-.221 1.196-.624 1.652a.833.833 0 1 0 1.25 1.102A4.16 4.16 0 0 0 22 16.166v-10A4.17 4.17 0 0 0 17.833 2M3.667 7.833V6.167c0-1.379 1.121-2.5 2.5-2.5h11.666c1.379 0 2.5 1.121 2.5 2.5v1.666z"
    }, null, -1)
  ]))]))
}
export default { render: render }